import {
  createContext,
  Dispatch,
  ReactElement,
  useContext,
  useState,
} from 'react';

import setTrailingZeros from 'utils/setTrailingZeros';

export type UserData = {
  name: string;
  amount: string;
  memo: string;
  bank: string;
  referralToken: string;
  publicId: string;
  senderId: number;
  receiverIdentifier: string;
  memoGifId: string;
  previousClaim?: {
    lastFour: string;
    firstName: string;
    externalCardId: string;
  };
  claimWithChime: boolean;
  flipperFlags: {
    graphqlUsage: any;
    ocrEnabled: boolean;
  };
  maintenanceMode: boolean;
};

const UserContext = createContext(null as any);

export function UserContextProvider(props): ReactElement {
  const [userData, setUserData] = useState<UserData>();
  const value = [userData, setUserData];

  return <UserContext.Provider value={value} {...props} />;
}

export function useUserContext(): [UserData, Dispatch<UserData>] {
  const userContext = useContext(UserContext);

  if (userContext[0])
    userContext[0].amount = setTrailingZeros(userContext[0].amount);

  if (!userContext) {
    throw new Error(
      'useUserContext should be used within a UserContextProvider'
    );
  }

  return userContext;
}
